import React, {useEffect, useState} from "react"
import {Col, Form, Row} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {checkEmptySpaces, LinkValidation, maxLength, Required} from "../../../../utils/patterns";
import TextInput from "../../../../components/common/input-field/TextInput";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import SelectField from "../../../../components/common/select-field/SelectField";
import {UserAuthService} from "../../../../services/user-auth-api.service";
import {notification} from "antd";
import {CloseRoundedCheck, RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import EditProfessionalSkeleton from "../../../skeletons/my-profile/edit-pages/EditProfessionalSkeleton";

export default function EditProfessional(options) {
    const [loader, setLoader] = useState(true)
    const [profileData, setProfileData] = useState(false)
    const [industryData, setIndustryData] = useState([])
    useEffect(() => {
        async function fetchInitialData() {
            setLoader(true)
            const api1Promise = UserAuthService.getProfileData();
            const api2Promise = UserAuthService.getIndustryData();

            const [response, response2] = await Promise.all([api1Promise, api2Promise]);

            if (response?.data?.data?.status && response2?.data?.data?.status) {
                const industry = response2.data.data.data.result;
                const formattedOptions = industry.map(item => ({
                    value: item._id,
                    label: item.name
                }));
                setIndustryData(formattedOptions);

                const userData = response.data.data.data.user;
                setProfileData(userData);

                const payload = {
                    pod: userData.podNumber,
                    b_name: userData.additionalFields.businessName,
                    b_industry: userData.businessIndustryId,
                    b_link: userData.additionalFields.websiteLink,
                };
                reset(payload); // Set initial form values here
                setLoader(false)
            }
        }

        fetchInitialData();
    }, []);

    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors,
        watch
    } = useForm({
        mode: 'onChange',
    })

    const onSubmit = async (data) => {
        setLoader(true)

        if(data){
            const industry = industryData.find(item => item.value === data.b_industry);
            let payload = {
                podNumber: data.pod,
                businessName: data.b_name,
                businessIndustryId: data.b_industry,
                additionalFields: {
                    businessName: data.b_name,
                    websiteLink: data.b_link,
                    businessIndustry : industry.label
                }
            }

            const response = await UserAuthService.updateProfileData(payload)

            if (response?.data?.data?.status){
                notification.success({
                    message: "Success",
                    description: response?.data?.message,
                    placement: "topRight",
                    icon: <RoundedCheck/>,
                    duration: 2,
                });
                options.close(false)
                setLoader(false)
            }
            else{
                notification.error({
                    message: "Failed",
                    description: response?.data?.message,
                    placement: "topRight",
                    icon: <CloseRoundedCheck/>,
                    duration: 2,
                });
            }
        }
    }

    const selectOption = [
        { value: 1, label: 'Option 1' },
        { value: 2, label: 'Option 2' },
    ];

    if(loader){
        return <EditProfessionalSkeleton/>
    }

    return(
        <div className={'signup'}>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md={12}>
                        <div className={'dfields'}>
                            <Controller
                                name="pod"
                                defaultValue={'Pod'}
                                control={control}
                                rules={{required: Required, maxLength: maxLength(100), validate: checkEmptySpaces,}}
                                render={({field: {name, ...field}}) => (
                                    <TextInput
                                        placeholder={'Enter pod'}
                                        label={'Enter Pod'}
                                        type={'text'}
                                        field={field}
                                        errors={errors.pod}
                                        className={'required'}
                                    />
                                )}
                            />
                        </div>
                    </Col>

                </Row>

                {profileData &&
                <div className={'dfields'}>
                    <Controller
                        name="b_industry"
                        defaultValue={profileData.businessIndustryId}
                        control={control}
                        rules={{required: Required}}
                        render={({field:{name, ...field}}) => (
                            <SelectField
                                showSearch={false}
                                label={'Business Industry'}
                                field={field}
                                placeholder={'Select Business Name'}
                                className={'required'}
                                options={industryData}
                                errors={errors.b_industry}
                                fieldName={name}
                                setValue={setValue}
                                defaultValue={profileData.businessIndustryId}
                            />
                        )}
                    />
                </div>
                }


                <div className={'dfields'}>
                    <Controller
                        name="b_name"
                        defaultValue={'Global Leagues'}
                        control={control}
                        rules={{required: Required, maxLength: maxLength(100), validate: checkEmptySpaces,}}
                        render={({field: {name, ...field}}) => (
                            <TextInput
                                placeholder={'Enter business Name'}
                                label={'Business Name'}
                                type={'text'}
                                field={field}
                                errors={errors.b_name}
                                className={'required'}
                            />
                        )}
                    />
                </div>

                <div className={'dfields'}>
                    <Controller
                        name="b_link"
                        defaultValue={'www.globalleagues.com'}
                        control={control}
                        rules={{required: Required, maxLength: maxLength(100), pattern: LinkValidation}}
                        render={({field: {name, ...field}}) => (
                            <TextInput
                                placeholder={'Enter business website link'}
                                label={'Business Website Link '}
                                type={'text'}
                                field={field}
                                errors={errors.b_link}
                                className={'required'}
                            />
                        )}
                    />
                </div>



                <div className={'dfields'} style={{marginTop:38}}>
                    <ThemeButton
                        text={'Save'}
                        className={'btn-light-lg'}
                        type={'submit'}
                        loader={loader}
                    />
                </div>
            </Form>
        </div>
    )
}